export default __webpack_public_path__ + "static/media/03.b35486cb.png";